import React from "react";
import {
  Document,
  Page,
  Image,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import { getFormattedDate, dateFormatType } from "@SeemplicityDev/shared";

const styles = StyleSheet.create({
  page: {
    paddingTop: 60,
    paddingBottom: 40,
    paddingHorizontal: 10,
    fontSize: 12,
  },
  widgetImage: {
    marginVertical: 5,
  },
  footer: {
    fontSize: 6,
    position: "absolute",
    bottom: 30,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#41425a",
  },
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
  lastImage: {
    position: "absolute",
    bottom: 50,
    left: 0,
    right: 0,
  },
});

interface EndOfYearPdfProps {
  imageDataUrls?: string[];
}

const EndOfYearPdf: React.FC<EndOfYearPdfProps> = ({ imageDataUrls }) => {
  const dateStr = getFormattedDate(
    new Date().toISOString(),
    dateFormatType.LONG
  );

  const headerImage = imageDataUrls?.[0];
  const otherImages = imageDataUrls?.slice(1);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header} fixed>
          <Image src={headerImage} style={styles.header} />
        </View>
        {otherImages?.map((img, idx) => (
          <Image
            key={idx}
            src={img}
            style={
              idx === otherImages.length - 1
                ? styles.lastImage
                : styles.widgetImage
            }
          />
        ))}
        <View style={styles.footer} fixed>
          <Text>© Seemplicity | {dateStr}</Text>
          <Text
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

export default EndOfYearPdf;
